import React, { useEffect, useState } from "react"
import { useSearchParams, useNavigate } from "react-router-dom"
import { Plus, Trash2, Copy } from "lucide-react"
import { queryTools } from "lib/utils"
import { useAppCtx, appStore } from "lib/state"
import { Modal, NewTemplateForm, Pagination, UnitTitleBlock } from 'lib/components';

const defaultParams = { _page: 1, _perpage: 25, _sortby: "createdAt", _sortdir: "asc" }

export default function TemplateList(){
  const navigate = useNavigate()

  const [ searchParams, setSearchParams ] = useSearchParams()
  const { AppStore }:any = appStore()
  const { update } = AppStore

  const [ queryParams, setQueryParams ] = useState<any>(defaultParams)
  const filters = { client: null, rp:null }

  const { data:_Templates } = queryTools.resource.parseQueryForApi("dispute.findAll", {...queryParams, ...filters}, { })
  // const { data:_Template } = queryTools.resource.parseQueryForApi("dispute.findOne", { Id: 50 }, {})
  const removeFn = queryTools.resource.remove(["dispute.all"])
  
  async function handleTemplateDelete(_id:string){
    removeFn.mutate({ resource: "template", idObj: { key: "_id", value: _id} })
  }

  const [ openModal, setOpenModal ] = useState(false)
  const [ formInit, setFormInit ] = useState<any>({})

  function prepQueryParams(){
    const _page = searchParams.get("_page") || defaultParams._page
    const _perpage = searchParams.get("_perpage") || defaultParams._perpage
    const _sortby = searchParams.get("_sortby") || defaultParams._sortby
    const _sortdir = searchParams.get("_sortdir") || defaultParams._sortdir
    setQueryParams({ _page, _perpage, _sortby, _sortdir })
  }

  function createTemplate(){
    setFormInit({})
    setOpenModal(true)
  }

  // function deleteTemplate(_id:string){
  //   console.log("delete template", _id)
  // }

  function showConfirmDelete(_id:string){
    update("ui.toast", {
      id: Date.now(),
      visible: true,
      message: "Are you sure you want to delete this template?",
      type: "confirm",
      onConfirm: async() => await handleTemplateDelete(_id)
    })
  }
  
  function cloneTemplate(_id:string){
    setFormInit({})
    const clone = _Templates?.find( (item:any) => item._id === _id)
    const newCopy = {...clone, Title: `Copy of ${clone.Title}`}
    setFormInit(newCopy)
    setOpenModal(true)
  }

  function handleTitleClick(_id:string){
    navigate(`/template/${_id}/build`)
  }

  useEffect(() => {
    prepQueryParams()
  },[searchParams.get("_page"), searchParams.get("_perpage"), searchParams.get("_sortby"), searchParams.get("_sortdir")])

  // useEffect(() => {
  //   console.log(_Template)
  // },[_Template])
  
  return (
    <div className="w-full h-full flex flex-col">

      <UnitTitleBlock className="" title="template manager">
        <Plus className="size-5 cursor-pointer stroke-1 stroke-gray-100" onClick={createTemplate} />
      </UnitTitleBlock>

      <Modal 
        size="lg"
        title="Create New Template" 
        status={openModal ? "open" : "closed"} 
        onClose={() => setOpenModal(false)}
      >
        <NewTemplateForm initData={formInit} setOpenModal={setOpenModal} />
      </Modal>

      { _Templates !== undefined && (
        <div className="w-full flex flex-col gap-3">
          <div className="w-full mt-4 px-4 grid grid-cols-12">
            <div className="w-full col-span-12 grid grid-cols-12 pb-2 border-b border-solid border-slate-700">
              <div className="col-span-1 flex justify-start items-end font-bold text-sm uppercase">id</div>
              <div className="col-span-5 flex justify-start items-end font-bold text-sm uppercase">title</div>
              {/* <div className="col-span-1 xl:col-span-2 flex justify-start items-end font-bold text-sm uppercase">use</div> */}
              {/* <div className="col-span-2 flex justify-start items-end font-bold text-sm uppercase">client</div>
              <div className="col-span-2 flex justify-start items-end font-bold text-sm uppercase">design</div>
              <div className="col-span-1 flex justify-start items-end font-bold text-sm uppercase">versions</div> */}
              <div className="col-span-1 flex justify-start items-end font-bold text-sm uppercase"></div>
            </div>
            { _Templates.map( (item:any) => (
              <div key={item._id} className="w-full h-10 hover:bg-teal-900/20 col-span-12 grid grid-cols-12 pb-2 border-b border-solid border-slate-700 cursor-pointer">
                <div className="col-span-1 h-10 flex justify-start items-center">{item.Id}</div>
                <div className="col-span-5 h-10 flex justify-start items-center" onClick={() => handleTitleClick(item._id)}>{item.title}</div>
                {/* <div className="col-span-1 xl:col-span-2 h-10 flex justify-start items-center">{item.Usage}</div> */}
                {/* <div className="col-span-2 h-10 flex justify-start items-center">{item.AssignedTo?.name || "[none]"}</div>
                <div className="col-span-2 h-10 flex justify-start items-center">def leppard</div>
                <div className="col-span-1 h-10 flex justify-start items-center">[soon!]</div> */}
                <div className="col-span-1 h-10 flex justify-end items-center gap-3">
                  <Copy className="size-5 cursor-pointer stroke-1" onClick={() => cloneTemplate(item._id)} />
                  <Trash2 className="size-5 cursor-pointer stroke-1" onClick={() => showConfirmDelete(item._id)} />
                </div>
              </div>
            ))}
          </div>
            
          { _Templates.total > _Templates.dataset?.length && (
            <Pagination 
              totalRecords={_Templates.total} 
              currentPage={queryParams._page} 
              recordsPerPage={queryParams._perpage}
              className="w-full mt-4"
            />
          )}

        </div>
      )}

    </div>
  )
}